import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

interface TypographyWrapProps {
	maxRows?: number
}

const TypographyWrap = styled(Typography, {
	shouldForwardProp: props => props !== 'maxRows',
})<TypographyWrapProps>(({ maxRows }) => ({
	display: '-webkit-box',
	WebkitLineClamp: maxRows,
	overflow: 'hidden',
	WebkitBoxOrient: 'vertical',
	wordBreak: 'break-word',
}))

export { TypographyWrap }
